export const verifiedTotal = (arr) => {
  const zero = arr[0];
  const val = zero[zero.length - 1];
  const condition = val.value === 'Total' ? true : false;
  return condition;
};

export const addTotal = (arr) => {
  const condition = verifiedTotal(arr);
  const newArr = arr.map((item, index) => {
    if (condition) {
      item.splice(item.length - 1, 1);
    }
    const r = item.reduce((acc, val, idx) => {
      if (idx > 0) {
        return acc + parseFloat(val.value);
      }
      return acc + 0;
    }, 0);
    if (index === 0) {
      return {'value': 'Total'};
    }
    return {'value': r};
  });

  return newArr;
};

export const mergeArr = (arr, arr2) => {
  const condition = verifiedTotal(arr);
  return arr.map((item, idx) => {
    if (condition) {
      item.splice(item.length - 1, 1);
    }
    return item.concat(arr2[idx]);
  });
};

export const parseArrToGridExcel = (arr, weeklen, editionEnabled) => {
  const newArr = [];
  const lenArr = arr.length - 1;
  arr.forEach((row, idxArr) => {
    const newRowArr = row.map((element, idx) => {
      return {
        'value': element.name || element,
        'readOnly': editionEnabled || validate({idx, idxArr}, lenArr, weeklen),
        'width': idx === 0 ? 200 : 120,
        'className': validate({idx, idxArr}, lenArr, weeklen) ? 'data-frame' : '',
        'id': element.id || element,
      };
    });

    newArr.push(newRowArr);
  });
  return newArr;
};

function validate({idx, idxArr}, lenArr, weekLen) {
  const firstElementRow = 0;
  const SecondElementRow = 1;
  if (idxArr === firstElementRow) {
    return true;
  } else if (idxArr === lenArr) {
    return true;
  } else if (idxArr === SecondElementRow) {
    return true;
  } else if (idx % weekLen === 0) {
    return true;
  } else if (idx === firstElementRow) {
    return true;
  }

  return false;
}

export const sumRow = (arr, weekLen) => {
  const newArr = [...arr];
  const READ_INIT_MODELS = 2;
  const LEN_UNTIL_TOTAL = newArr.length - 1;
  const idxTotal = searchIdxTotal(newArr[1]);
  for (let i = READ_INIT_MODELS; i < LEN_UNTIL_TOTAL; i++) {
    const element = newArr[i];
    for (let y = 0; y < idxTotal.length; y++) {
      const end = idxTotal[y];
      const arrSlice = element.slice(end - weekLen, end);
      const sumElements = sumArr(arrSlice);
      element[end].value = sumElements;
    }
  }

  return newArr;
};

export const sumCol = (arr, modelsLen) => {
  const newArray = arr.slice();
  const ROW_LEN = arr[0].length;

  for (let i = 1; i < ROW_LEN; i++) {
    let sum = 0;
    for (let y = 0; y < modelsLen; y++) {
      const value = newArray[y + 2][i];
      sum = parseFloat(value.value) + sum;
    }
    newArray[modelsLen + 2][i] = {'value': sum, 'readOnly': true};
  }

  const sumCols = sumRow(newArray, 4);
  return sumCols;
};

function searchIdxTotal(arr) {
  const result = [];
  arr.forEach((element, idx) => {
    if (element.value.toUpperCase() === 'TOTAL') {
      result.push(idx);
    }
  });

  return result;
}

function sumArr(row) {
  let result = 0;
  row.forEach((element) => {
    result = parseFloat(element.value) + result;
  });

  return result;
}
